module.exports = __webpack_public_path__ + "img/partner06.69a13970.png";